import useSWR from "swr";
import { apiClient, type AskSession } from "@/api/client";

interface UseGlobalAskSessionsReturn {
  sessions: AskSession[];
  isLoading: boolean;
  isError: boolean;
  oldestSession: AskSession | null;
  canCreateNew: boolean;
  refresh: () => void;
}

export function useGlobalAskSessions(): UseGlobalAskSessionsReturn {
  const { data, error, isLoading, mutate } = useSWR(
    "global-ask-sessions",
    () => apiClient.listAllSessions().then((r) => r.sessions),
    {
      refreshInterval: 180000, // 3 minutes
      revalidateOnReconnect: false,
    },
  );

  const sessions = data ?? [];

  // Find the oldest session by last_activity_at (this is the one that would be deleted)
  const oldestSession =
    sessions.length > 0
      ? sessions.reduce((oldest, current) =>
          new Date(current.last_activity_at) < new Date(oldest.last_activity_at)
            ? current
            : oldest,
        )
      : null;

  return {
    sessions,
    isLoading,
    isError: !!error,
    oldestSession,
    canCreateNew: sessions.length < 3,
    refresh: () => void mutate(),
  };
}
